export var CharityStatus;
(function (CharityStatus) {
    CharityStatus["approved"] = "STATUSAPPROVED";
    CharityStatus["pendingApproval"] = "STATUSPENDINGAPPROVAL";
    CharityStatus["rejected"] = "STATUSREJECTED";
})(CharityStatus || (CharityStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcml0eXN0YXR1cy5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjaGFyaXR5c3RhdHVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLGFBSVg7QUFKRCxXQUFZLGFBQWE7SUFDdkIsNENBQTJCLENBQUE7SUFDM0IsMERBQXlDLENBQUE7SUFDekMsNENBQTJCLENBQUE7QUFDN0IsQ0FBQyxFQUpXLGFBQWEsS0FBYixhQUFhLFFBSXhCIn0=